export enum AgencyUserStatus {
  Active = 'active',
  InActive = 'in-active',
  Invited = 'invited',
}
